// extracted by mini-css-extract-plugin
export default {"flag":"FormFieldActiveInLanguages_flag__TQU7A"};